import Requests from "@/services/Requests";

const state = {
  customers: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  allCustomers: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  createStatus: "unitiliazed", // unitiliazed, loading, success, error
  updateStatus: "unitiliazed", // unitiliazed, loading, success, error
  deleteStatus: "unitiliazed", // unitiliazed, loading, success, error
  customerById: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
};
const getters = {
  /**
   * Returns a subset of customers based on the given page number.
   *
   * @param {Object} state - The Vuex state object.
   * @param {number} [page=0] - The page number to filter customers by. Defaults to 0.
   * @return {Array} An array of customers filtered by the given page number. If page is 0, returns all customers.
   */
  getCustomers:
    (state) =>
    (page = 0) =>
      page === 0
        ? state.customers.data
        : state.customers.data
            .filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.id === value.id)
            )
            .filter((d) => d.page === page),
  getAllCustomers: (state) => state.allCustomers.data,
  getCustomerStatus: (state) => state.customers.status,
  getCustomerCount: (state) => state.customers.count,
  getCustomerPage: (state) => state.customers.page,
  getCustomerPages: (state) => Math.ceil(state.customers.count / 10),
  getCustomersLoading: (state) => state.customers.status === "loading",
  getCustomerById: (state) => (id) =>
    state.customerById.data.find((d) => d.id === id) || {},
};
const mutations = {
  /**
   * Updates the status of the customer in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the customer.
   */
  SET_CUSTOMER_STATUS(state, payload) {
    console.log(state.customers, "status: ", payload);
    state.customers.status = payload;
  },
  /**
   * Sets the customers and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of customers.
   * @param {number} payload.count - The total count of customers.
   */
  SET_CUSTOMERS(state, payload) {
    state.customers.data = payload.items;
    state.customers.count = payload.count;
  },
  /**
   * Sets the customers and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of customers.
   * @param {number} payload.count - The total count of customers.
   */
  SET_ALL_CUSTOMERS(state, payload) {
    state.allCustomers.data = payload.items;
    state.allCustomers.count = payload.count;
  },
  /**
   * Updates the status of the update customer in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the customer.
   */
  SET_UPDATE_CUSTOMER_STATUS(state, payload) {
    state.updateStatus = payload;
  },
  /**
   * Updates an customer object in the state with new information.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The updated customer object.
   * @return {void}
   */
  SET_UPDATE_CUSTOMER(state, payload) {
    const index = state.customers.data.findIndex((d) => d.id === payload.id);
    const customer = state.customers.data[index];
    state.customers.data[index] = { ...customer, ...payload };
  },
  SET_CREATE_CUSTOMER_STATUS(state, payload) {
    state.createStatus = payload;
  },
  /**
   * Adds a new customer to the list of customers in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The customer object to be added.
   * @return {void}
   */
  SET_CREATE_CUSTOMER(state, payload) {
    state.customers.data.push(payload);
  },
  /**
   * Updates the status of the delete customer in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the customer.
   */
  SET_DELETE_CUSTOMER_STATUS(state, payload) {
    state.deleteStatus = payload;
  },
  /**
   * Removes an customer from the state based on the provided payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the customer ID to be deleted.
   * @param {number} payload.id - The ID of the customer to be deleted.
   * @return {void}
   */
  SET_DELETE_CUSTOMER(state, payload) {
    state.customers.data = state.customers.data.filter(
      (d) => d.id !== payload.id
    );
  },
  SET_CUSTOMER_BY_ID_STATUS(state, payload) {
    state.customerById.status = payload;
  },
  SET_CUSTOMER_BY_ID(state, payload) {
    state.customerById.data.push(payload);
  },
};

const actions = {
  /**
   * Retrieves a list of customers based on the provided payload.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the query parameters.
   * @param {Object} payload.query - The query parameters.
   * @param {string} payload.query.searchKey - The search key.
   * @param {string} payload.query.regionId - The region ID.
   * @param {string} payload.query.companyId - The company ID.
   * @param {number} payload.query.page - The page number.
   * @return {Promise<void>}
   */
  async getCustomers({ commit }, payload) {
    commit("SET_CUSTOMER_STATUS", "loading");
    const response = await Requests.Customer.GetAll(payload);
    if (response.message === "OK") {
      commit("SET_CUSTOMERS", {
        items: response.data.items.map((item) => ({
          ...item,
          page: payload.query.page,
        })),
        count: response.data.count,
      });

      if (payload.initial)
        commit("SET_ALL_CUSTOMERS", {
          items: response.data.items.map((item) => ({
            ...item,
            page: payload.query.page,
          })),
          count: response.data.count,
        });
      commit("SET_CUSTOMER_STATUS", "success");
      return response.data;
    }
    commit("SET_CUSTOMER_STATUS", "success");
    return { count: 0, items: [] };
  },
  /**
   * Creates an customer by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the customer data.
   * @param {string} payload.fullName - The full name of the customer.
   * @param {string} payload.phoneNumber - The phone number of the customer.
   * @param {string} payload.email - The email of the customer.
   * @param {string} payload.regionId - The ID of the region the customer belongs to.
   * @param {File} payload.image - The image of the customer.
   * @param {number} payload.workStartTime - The start time of the work day.
   * @param {number} payload.workEndTime - The end time of the work day.
   * @return {Promise<void>} - A promise that resolves when the creation is complete.
   */
  async createCustomer({ state, commit }, payload) {
    state.createStatus = "loading";
    try {
      const response = await Requests.Customer.Create(payload);
      state.createStatus = "success";
      if (response.message === "OK")
        commit("SET_CREATE_CUSTOMER", {
          id: response.data,
          fullName: payload.fullName,
          phoneNumber: payload.phoneNumber,
          email: payload.email,
          regionId: payload.regionId,
          image: payload.image,
          workStartTime: payload.workStartTime,
          workEndTime: payload.workEndTime,
          page: 1,
        });
      else state.createStatus = "error";
    } catch {
      state.createStatus = "error";
    }
  },
  /**
   * Updates an customer by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the customer data to update.
   * @param {string} payload.fullName - The full name of the customer.
   * @param {string} payload.phoneNumber - The phone number of the customer.
   * @param {string} payload.email - The email of the customer.
   * @param {string} payload.regionId - The ID of the region the customer belongs to.
   * @param {File} payload.image - The image of the customer.
   * @param {number} payload.workStartTime - The start time of the work day.
   * @param {number} payload.workEndTime - The end time of the work day.
   * @param {boolean} payload.isActive - Whether the customer is active or not.
   * @return {Promise<void>} - A promise that resolves when the update is complete.
   */
  async updateCustomer({ state, commit }, payload) {
    state.updateStatus = "loading";
    try {
      const response = await Requests.Customer.Update(payload, {
        params: { id: payload.id },
      });
      if (response.message === "OK") {
        commit("SET_UPDATE_CUSTOMER", payload);
        state.updateStatus = "success";
      } else {
        state.updateStatus = "error";
      }
      return response.message;
    } catch {
      state.updateStatus = "error";
      return { message: "FAIL" };
    }
  },
  /**
   * Removes an customer from the state and updates the delete status.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the customer data.
   * @param {number} payload.id - The ID of the customer to be removed.
   * @returns {Promise<void>} A promise that resolves when the customer is successfully removed.
   */
  removeCustomer({ state }, { id }) {
    state.deleteStatus = "loading";

    return Requests.Customer.Delete({ params: { id } })
      .then((response) => {
        const result = response.message === "OK" ? "OK" : "error";
        state.deleteStatus = result;
        return result;
      })
      .catch(() => {
        const result = "error";
        state.deleteStatus = result;
        return result;
      });
  },
  /**
   * Retrieves an customer by their ID and updates the customer by ID status in the Vuex store.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} id - The ID of the customer to retrieve.
   * @return {Promise} A promise that resolves when the customer is successfully retrieved and the status is updated.
   */
  getCustomerById({ commit, state }, { id }) {
    // check if customer already exists in the state;
    if (state.customerById.data.find((customer) => customer.id === id))
      return state.customerById.data.find((customer) => customer.id === id);
    commit("SET_CUSTOMER_BY_ID_STATUS", "loading");
    return Requests.Customer.GetById({ params: { id } })
      .then((response) => {
        commit("SET_CUSTOMER_BY_ID", response.data);
        commit("SET_CUSTOMER_BY_ID_STATUS", "success");
        return response.data;
      })
      .catch(() => {
        commit("SET_CUSTOMER_BY_ID_STATUS", "error");
        return {};
      });
  },
};

export default { state, getters, mutations, actions };
